<template>
  <div>
    <LayoutContent>
      <SectionTitle :label="$t('label.orderDetails')" />
      <div v-for="detail in details" :key="detail.order.order_id">
        <v-container class="white rounded-lg">
          <v-row no-gutters>
            <v-col cols="12" sm="4" class="px-5">
              <h5 class="secondary--text text--lighten-2">{{ $t('label.orderId') }}</h5>
              <p class="black--text text-body-2">{{ detail.order.po_number }}</p>
            </v-col>
            <v-divider vertical />
            <v-col cols="12" sm="4" class="px-5">
              <h5 class="secondary--text text--lighten-2">{{ $t('label.orderTime') }}</h5>
              <p class="black--text text-body-2">{{ detail.order.created_at }}</p>
            </v-col>
            <v-divider vertical />
            <v-col cols="12" sm="4" class="px-5">
              <h5 class="secondary--text text--lighten-2">{{ $t('label.paymentTime') }}</h5>
              <p class="black--text text-body-2">{{ detail.order.issue_date }}</p>
            </v-col>
          </v-row>
        </v-container>
        <v-row class="mt-5 mb-8">
          <v-col>
            <v-card class="white rounded-lg pa-5" outlined tile>
              <div v-if="detail.order.delivery_date">
                <div class="mb-2">
                  <h5 class="secondary--text text--lighten-2">{{ $t('label.deliveryDateAndTime') }}</h5>
                  <p class="black--text text-body-2">{{ detail.order.delivery_date }}</p>
                </div>
                <v-divider />
              </div>
              <div v-if="detail.delivery_address">
                <div class="my-2">
                  <h5 class="secondary--text text--lighten-2">{{ $t('label.deliveryAddress') }}</h5>
                  <p class="black--text text-body-2">{{ detail.delivery_address }}</p>
                </div>
                <v-divider />
              </div>
              <div class="my-2">
                <div class="d-flex flex-row justify-space-between">
                  <h5 class="secondary--text text--lighten-2">{{ $t('label.paymentInformation') }}</h5>
                  <h5 class="secondary--text text--lighten-2">{{ detail.order.currency }}</h5>
                </div>
                <div class="d-flex flex-row justify-space-between">
                  <p class="black--text text-body-2">{{ $t('label.merchandiseTotal') }}:</p>
                  <p class="black--text text-body-2">{{ detail.order.total_amount.toFixed(2) }}</p>
                </div>
                <div class="d-flex flex-row justify-space-between">
                  <p class="black--text text-body-2">{{ $t('label.pointRedemption') }}:</p>
                  <p class="black--text text-body-2">-{{ detail.order.point_redemption_amount.toFixed(2) }}</p>
                </div>
                <div class="d-flex flex-row justify-space-between">
                  <p class="black--text text-body-2">{{ $t('label.tax') }}{{ detail.order.tax_charge ? `(${detail.order.tax_percentage})` : '' }}:</p>
                  <p class="black--text text-body-2">{{ detail.order.tax_charge ? detail.order.tax_charge.toFixed(2) : '-' }}</p>
                </div>
                <div class="d-flex flex-row justify-space-between">
                  <p class="black--text text-body-2">{{ $t('label.deliveryFee') }}:</p>
                  <p class="black--text text-body-2">{{ Number(detail.order.shipping_charge) ? detail.order.shipping_charge.toFixed(2) : detail.order.shipping_charge }}</p>
                </div>
                <div class="d-flex flex-row justify-space-between">
                  <p class="text-body-1 primary--text text--darken-1 font-weight-bold">{{ $t('label.totalPayment') }}:</p>
                  <p class="text-body-1 primary--text text--darken-1 font-weight-bold">{{ detail.order.currency }}</p>
                  <p class="text-body-1 primary--text text--darken-1 font-weight-bold">{{ detail.order.final_amount.toFixed(2) }}</p>
                </div>
              </div>
              <v-divider />
              <div class="my-2">
                <h5 class="secondary--text text--lighten-2">{{ $t('label.paymentMethod') }}</h5>
                <p class="black--text text-body-2">{{ detail.order.payment_method_name }}</p>
              </div>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="white rounded-lg pa-5" outlined tile>
              <h3 class="text-subtitle-1 secondary--text font-weight-bold">{{ $t('label.checkOut') }} ({{ detail.order.items.length }})</h3>
              <div class="d-flex flex-row my-5" v-for="orderItem in detail.order.items" :key="orderItem.order_id">
                <img :src="orderItem.product_image" class="mr-5 order-image rounded-lg elevation-3" />
                <div>
                  <p class="text-subtitle-2 font-weight-bold grey--text">
                    {{ orderItem.product_subcategory_name }}
                  </p>
                  <p class="text-subtitle-2 secondary--text">
                    {{ orderItem.product_name }}
                  </p>
                  <p class="text-subtitle-2 secondary--text">
                    {{ orderItem.product_volume_variation_name }}
                  </p>
                  <p class="text-body secondary--text font-weight-medium">{{ orderItem.currency }} {{ orderItem.unit_price }}</p>
                  <p class="text-body secondary--text font-weight-medium">{{ $t('label.qty') }}: {{ orderItem.quantity }}</p>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </LayoutContent>
    <bottom-bar>
      <v-container class="py-3 d-flex">
        <router-link :to="{ name: $constants.ROUTE_NAME.ORDER_DASHBOARD }" class="mx-auto text-decoration-none">
          <v-btn color="white" class="px-10 d-block rounded-pill text-capitalize primary--text text--darken-1 font-weight-medium">
            {{ $t('label.backToMyOrder') }}
          </v-btn>
        </router-link>
      </v-container>
    </bottom-bar>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import LayoutContent from '@/views/layouts/LayoutContent.vue'
import SectionTitle from '@/components/SectionTitle.vue'
export default {
  components: { LayoutContent, SectionTitle },
  name: 'Detail',
  data: () => ({
    details: [],
    poNumbers: []
  }),
  created() {
    this.poNumbers = Array.isArray(this.$route.query.po_number) ? this.$route.query.po_number : [this.$route.query.po_number]
    this.fetchDetail()
  },
  methods: {
    ...mapActions('order', ['getMultipleOrderDetail']),
    fetchDetail() {
      this.getMultipleOrderDetail(this.poNumbers.join()).then((res) => {
        this.details = res.map((detail) => {
          detail.order.shipping_charge = this.shippingFee(detail.order)
          return detail
        })
      })
    },
    shippingFee(order) {
      if (order.items.find((item) => item.product_category_id == 7)) {
        return '-'
      }
      return order.shipping_charge + order.min_charge || this.$t('label.free')
    }
  }
}
</script>

<style lang="scss" scoped>
.order-image {
  width: 120px;
  height: 120px;
  object-fit: cover;
}
</style>
